import React from 'react';
import PropTypes from "prop-types";

import styles from "./DashboardRadio.module.css";

export default function DashboardRadio({isSelected, onChange, value, label}){

return (
    <div className={styles.container}>
      <input
        type="radio"
        id={value}
        checked={isSelected}
        onChange={() => onChange(value)}
        value={value}
      />
      {label && <label className={styles.radio_label} htmlFor={value}>{label}</label>}
    </div>
);
};

DashboardRadio.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string
}